import FormInputTypes from '../components/atoms/formEnums/formInputTypes';

export default {
  attributeName: 'vtproviders',
  isDragable: false,
  canOpen: false,
  canEdit: false,
  canCreate: false,
  canRemove: false,
  isSelectable: true,
  isMultiSelectable: true,
  getURL: 'organization/organizationId/agreements/vtproviders',
  sessionParams: ['organizationId'],
  emptyMessage: "There is no provider associated",
  fields: [
    {
      attributeName: 'appName',
      label: 'App Name',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      default: '',
      canOrder: true,
      canFilter:true,
      canEdit: false,
      canCreate: false,
      helpText: 'Name of the category.',
    },
    {
      attributeName: 'name',
      label: 'Provider Name',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      default: '',
      canOrder: true,
      canFilter:true,
      canEdit: false,
      canCreate: false,
      helpText: 'Name of the category.',
    }
  ],
};
